module.exports = __webpack_public_path__ + "img/Gossypium_raimondii.1ab1dd9f.jpg";